<template>
<div>
  <h2 style="padding: 0px; color: gray">{{'nonEditableItems' | phrasemap}}</h2>
    <v-layout wrap style="margin-left: 12px;"> 
    <v-flex v-for="eitem in editables" 
    v-show="eitem.readonly || (editedItem[eitem.name] && editedItem._fields && editedItem._fields.includes(eitem.name))" :key="eitem.name" xs12 sm6 md4 lg3 xl2>
        <v-layout row>
          <span style="font-size: larger; color: grey"> 
            <div v-html="eitem.header"></div>
          </span> : 
          <div style="padding-top: 2px; padding-left: 3px;">
            {{formatItem({i:editedItem, h:headers.filter(i=>i.value==eitem.name)[0], e:editables})}}
          </div>
          </v-layout>
    </v-flex>
  </v-layout>
  </div>
</template>

<script>
import utils from '../helpers/utils'
export default {
  props: ['editables', 'editedItem', 'headers'],
  methods: {
    formatItem (item) {
      return utils.formatItem(item)
    }
  },
  mounted () {
    console.log('Displaying read only items ', this.editables, this.editedItem, this.headers)
  }
}
</script>